export function transformStringOutput(value?: string | null): string | null | undefined {
    return !value ? null : value;
}
